import React from 'react';
import { PropTypes } from 'prop-types';
// logic
import { useTranslation } from 'react-i18next';
// state
import { useSelector } from 'react-redux';
import { selectors as uiSelectors } from 'state/ui';
import { selectors as authSelectors } from 'state/auth';
import { selectors as settingsSelectors } from 'state/settings';
// style
import styled, { css } from 'styled-components';
import { media } from 'utils/style';
import {
  MAIN_MENU_COLLAPSED_WIDTH,
  MAIN_MENU_WIDTH,
} from '../nav/mainMenu/MainMenuBar';
// components
import TopAdvice from 'components/TopAdvice';
import DeniedMethodAdvice from 'components/orders/DeniedMethodAdvice';
import Feedback from 'components/Feedback';
import FeedbackError from 'components/FeedbackError';

const PageContainer = styled.div`
  flex-grow: 1;
  overflow: auto;
  display: flex;
`;

const PageWithFeedback = ({ className, children, isMainMenuOpened }) => {
  const { t } = useTranslation(['Communications']);
  const feedback = useSelector(uiSelectors.getFeedback);
  const feedbackParams = useSelector(uiSelectors.getFeedbackParams);
  const success = useSelector(uiSelectors.getFeedbackSuccess);
  const isPaymentMethodDenied =
    useSelector(authSelectors.getPaymentDataPaymentMethodValidationStatus) ===
    'DENIED';
  const country = useSelector(settingsSelectors.getCountrySettings)?.country;

  return (
    <div className={className}>
      {/* top feedback */}
      {country === 'UK' && <TopAdvice>{t('uk_closure')}</TopAdvice>}
      {isPaymentMethodDenied && <DeniedMethodAdvice />}
      {/* page */}
      <PageContainer>{children}</PageContainer>
      {/* bottom feedback */}
      {!!feedback && success && (
        <Feedback feedback={feedback} params={feedbackParams} />
      )}
      {!!feedback && !success && (
        <FeedbackError feedback={feedback} success={success} />
      )}
    </div>
  );
};

PageWithFeedback.propTypes = {
  isMenuOpened: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
};

const regularCSS = css`
  margin-left: ${MAIN_MENU_WIDTH};
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: auto;
  flex-grow: 1;
  transition: margin-left 0.3s ease;
`;

const smallDesktopCSS = css`
  margin-left: ${MAIN_MENU_WIDTH};
  ${(props) =>
    !props.isMainMenuOpened &&
    css`
      margin-left: ${MAIN_MENU_COLLAPSED_WIDTH};
    `}
`;

const tabletCSS = css`
  margin-left: ${MAIN_MENU_COLLAPSED_WIDTH};
`;

const mobileCSS = css`
  margin-left: 0;
`;

export default styled(PageWithFeedback)`
  ${regularCSS};
  ${media.lessThan('huge')`${smallDesktopCSS}`};
  ${media.lessThan('large')`${tabletCSS}`};
  ${media.lessThan('small')`${mobileCSS}`};
`;
